import {BASE_URL, FILE_URL} from "../../config";
import Image from './Image'
import  {ReactComponent as CalcImage} from '../../img/calc.svg'

export function CheckImg(str='') {
    if (!str) {
        return [];
    }

    const urlImg = str.match(/\{!img\s*(.*?)\s*!\}/g) || [];
    let count1 = 0;
    let text = [];

    urlImg.forEach((item, i) => {
        const indexItem = str.indexOf(item);
        const name = str.substring(count1, indexItem);
        text.push(name);
        text.push(item);
        count1 = indexItem + item.length;

        if (i === urlImg.length - 1) {
            const remainingText = str.substring(count1);
            text.push(remainingText);
        }
    });
    return text;
}


function specialTools(name){
    if(name==='calc'){
        return <>
            <a href="calculator://"><CalcImage/></a>
            {/*<a href="osk.exe">Открыть экранную клавиатуру</a>*/}
        </>
    }
}

function extractSubstrings(str='') {
    const substrings = [];
    let currentIndex = 0;

    while (currentIndex < str.length) {
        const openingBracketIndex = str.indexOf('[!', currentIndex);
        const closingBracketIndex = str.indexOf('!]', currentIndex);

        const openingSlashIndex = str.indexOf('[/', currentIndex);
        const closingSlashIndex = str.indexOf('/]', currentIndex);

        const openingUnderscoreIndex = str.indexOf('[_', currentIndex);
        const closingUnderscoreIndex = str.indexOf('_]', currentIndex);

        const openingSpecialIndex = str.indexOf('{!', currentIndex);
        const closingSpecialIndex = str.indexOf('!}', currentIndex);

        const openingSelectIndex = str.indexOf('{{', currentIndex);
        const closingSelectIndex = str.indexOf('}}', currentIndex);

        const indexes = [
            { opening: openingBracketIndex, closing: closingBracketIndex, start: '[!', end: '!]' },
            { opening: openingSlashIndex, closing: closingSlashIndex, start: '[/', end: '/]' },
            { opening: openingUnderscoreIndex, closing: closingUnderscoreIndex, start: '[_', end: '_]' },
            { opening: openingSpecialIndex, closing: closingSpecialIndex, start: '{!', end: '!}' },
            { opening: openingSelectIndex, closing: closingSelectIndex, start: '{{', end: '}}' },
        ];

        const validIndexes = indexes.filter(({ opening, closing }) => opening !== -1 && closing !== -1 && closing > opening);

        if (validIndexes.length === 0) {
            break;
        }

        const earliestIndex = validIndexes.reduce((acc, curr) => curr.opening < acc.opening ? curr : acc);

        if (earliestIndex.opening > currentIndex) {
            substrings.push(str.slice(currentIndex, earliestIndex.opening));
        }

        const substringStart = earliestIndex.opening + earliestIndex.start.length;
        const substringEnd = earliestIndex.closing;
        const substring = str.slice(substringStart, substringEnd);
        substrings.push(`${earliestIndex.start}${substring}${earliestIndex.end}`);

        currentIndex = substringEnd + earliestIndex.end.length;
    }

    if (currentIndex < str.length) {
        substrings.push(str.slice(currentIndex));
    }
    return substrings.map((item, i) => {
        if (item.startsWith('[!')) {
            return <span key={i} style={{ fontWeight: 'bold' }}>{extractSubstrings(item.substring(2, item.length - 2))}</span>
        }
        if (item.startsWith('[_')) {
            return <span key={i} style={{ textDecorationLine: 'underline' }}>{extractSubstrings(item.substring(2, item.length - 2))}</span>
        }
        if (item.startsWith('[/')) {
            return <span key={i} style={{ fontStyle: 'italic' }}>{extractSubstrings(item.substring(2, item.length - 2))}</span>
        }
        if (item.startsWith('{{')) {
            return <span key={i} style={{ 'WebkitUserSelect': 'text','userSelect': 'text' }}>{extractSubstrings(item.substring(2, item.length - 2))}</span>
        }
        if (item.startsWith('{!')) {
            return <span key={i}>{specialTools(item.substring(2, item.length - 2))}</span>
        }
        return item;
    });
}
    function convertStringToJson(inputString) {
    const pattern = /{!img:(.*?),property:(.*?)!}/;
    const match = inputString.match(pattern);
    if (match) {
        const imgId = match[1];
        // const properties = .replace(/'/g, '"'); // Замена одинарных кавычек на двойные для правильного формата JSON
        const propertyMatch = match[2].match(/{width:(.*?),height:(.*?),wrapping:(.*?)}/);
        const width = propertyMatch?.[1];
        const height = propertyMatch?.[2];
        const wrapping = propertyMatch?.[3];
        return  {
            img_id: imgId,
            property: {
                width: parseInt(width),
                height: parseInt(height),
                wrapping:wrapping
            }
        };
    } else {
        return null;
    }
}

export function ReturnTextAndImg(str, style = { border: '2px solid black' }) {
    const text = CheckImg(str);

    const renderContent = (element) => {
        if (element.includes('{!img')) {
            if(element[5]===':') {
                const imageJson = convertStringToJson(element)
                const src = `${BASE_URL}${FILE_URL}/${imageJson.img_id}`;

                const { property } = imageJson || {}; // Destructure `property` from `imageJson` object
                const { width, height, wrapping } = property || {}; // Destructure `wrapping` from `property` object

                const styles = {
                    ...style,
                    width: `${width}px`, // Use template literal for width with 'px' unit
                    height: `${height}px`, // Use template literal for height with 'px' unit
                    float: wrapping || undefined,
                    margin: wrapping === 'left' ? '0 7px 0 0' : wrapping === 'right' ? '0 0 0 7px' : '0'
                };

                return (
                    <Image src={src} alt="media" key={`NewKey1${element}`}
                         style={styles}
                    />
                );
            }
            else{//поддержка страных версий
                const imageUrl = element.replace("{!img", '').replace('!}', '');
                const src = `${BASE_URL}${FILE_URL}/${imageUrl}`;

                return (
                    <img src={src} alt="media" key={`NewKey1${element}`} style={style} />
                );
            }
        } else {
            return extractSubstrings(element)
        }
    };

    return (
        <pre>
      {text.length !== 0 ? text.map((element) => renderContent(element)) : extractSubstrings(str)}
    </pre>
    );
}

